import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import App from './App'
import './styles/globals.css'


if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  })
}

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/*
      Invitation-only auth surface. signInUrl routes Clerk's own redirects
      (e.g. <RedirectToSignIn>) to the in-app /sign-in page, which preserves
      the redirect_url round-trip for protected deep links. No signUpUrl is
      set: a signUpUrl that merely bounced back to /sign-in would surface a
      visible sign-up affordance or a redirect loop. The sign-up affordance is
      instead suppressed directly on <SignIn withSignUp={false}> in App.tsx.
    */}
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      signInUrl="/sign-in"
      signInFallbackRedirectUrl="/today"
      afterSignOutUrl="/sign-in"
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
)
